import axios from "axios"
import { Dispatch } from "redux"
import {AUTH_URL } from "../constants"
import { ANALYTICS_FAIL, ANALYTICS_REQUEST, ANALYTICS_SUCCESS } from "../constants/analyticsConstants"


export const getAnalytics = (startDate: string | null, endDate: string | null, branch: string | null, year: any)=> async(dispatch: Dispatch)=>{
    try {

        dispatch({type: ANALYTICS_REQUEST})

        const {data} = await axios.post(`${AUTH_URL}/analytics`, {startDate, endDate, branch, year}, {withCredentials: true})

        dispatch({type: ANALYTICS_SUCCESS, payload: data})
        
    } catch (error:any) {

        dispatch({type: ANALYTICS_FAIL, payload: error.response && error.response.data.message ? error.response.data.message : error.message})
    }
}
